/** Constructor parameters of {@link Position}. */
export interface PositionInit {
  latitude: number;
  longitude: number;
  speed: number;
  accuracy: number;
  altitude: number;
  altitudeAccuracy: number;
  heading: number;
  timestamp: number;
}

export class Position {
  Latitude: number;
  Longitude: number;
  Speed: number;
  Altitude: number;
  Accuracy: number;
  AltitudeAccuracy: number;
  Heading: number;
  Timestamp: number;

  constructor({ latitude, longitude, speed, accuracy, altitude, altitudeAccuracy, heading, timestamp }: PositionInit) {
    this.Latitude = latitude;
    this.Longitude = longitude;
    this.Speed = speed;
    this.Accuracy = accuracy;
    this.Altitude = altitude;
    this.AltitudeAccuracy = altitudeAccuracy;
    this.Heading = heading;
    this.Timestamp = timestamp;
  }
}
